module.exports = __webpack_public_path__ + "img/detras.171a8c0.png";